import { render, staticRenderFns } from "./referenceData.vue?vue&type=template&id=01635ad0&scoped=true"
import script from "./referenceData.vue?vue&type=script&lang=js"
export * from "./referenceData.vue?vue&type=script&lang=js"
import style0 from "./referenceData.vue?vue&type=style&index=0&id=01635ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01635ad0",
  null
  
)

export default component.exports